import test from "./test";
import BearCheckedItem from "./bear-checked-item";
import BearTenderEditor from "./tender-editor";
import BearTenderViewer from "./tender-viewer";
import BearSign from "./sign";
import BearSelect from "./select";
import BearTimeSelect from "./time-select";
import BearFileList from "./file-list";
import BearLink from "./link";
import BearInput from "./input";
import BearEditor from "./tinymce-editor";
import BearDatePicker from "./date-picker";
import BearTradeCenter from "./bear-trade-center";
import BearPointsCollection from "./bear-points-collection";
import BearRemarkLink from "./bear-remark-link";

import Input from "./directives/input";

const components = [
  test,
  BearCheckedItem,
  BearTenderEditor,
  BearTenderViewer,
  BearSign,
  BearSelect,
  BearTimeSelect,
  BearFileList,
  BearLink,
  BearInput,
  BearEditor,
  BearDatePicker,
  BearTradeCenter,
  BearPointsCollection,
  BearRemarkLink
];

const install = (vue) => {
  if (vue.installed) return false;

  Input.init(vue);

  components.map((component) => {
    vue.use(component);
  });
};

if (typeof window !== "undefined" && window.vue) {
  install(window.vue);
}

export default {
  install,
  test,
};

export { test };
